import { useState, useEffect } from 'react'
import type { RateInfo } from '../types/electricity'
import { getCurrentRate } from '../utils/electricity'

export function useCurrentRate(): RateInfo {
  const [rate, setRate] = useState<RateInfo>(() => getCurrentRate())

  useEffect(() => {
    const interval = setInterval(() => {
      setRate(getCurrentRate())
    }, 60_000) // Re-evaluate every minute

    return () => clearInterval(interval)
  }, [])

  return rate
}
